import React from 'react'

function NotFound() {
  return (
    <div>
    <h5>Sorry but this pages doesn't exist!  </h5></div>
  )
}

export default NotFound